import React from "react";
import { Box, Typography } from "@mui/material";
import { FraudExplanation as Explanation } from "../../services/fraudService";

/** The server's plain-English reading: headline, summary, the recommendation highlighted, the caveat muted. */
const FraudExplanation: React.FC<{ explanation: Explanation }> = ({ explanation }) => (
    <Box data-testid="fraud-explanation" sx={{ whiteSpace: "normal" }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>{explanation.headline}</Typography>
        <Typography variant="body2" sx={{ mb: 1.5 }}>{explanation.summary}</Typography>
        <Box
            data-testid="fraud-recommendation"
            sx={{ mb: 1, p: 1.5, borderRadius: 1, borderLeft: "4px solid", borderColor: "warning.main", bgcolor: "rgba(237, 108, 2, 0.08)" }}
        >
            <Typography variant="body2"><strong>What to do:</strong> {explanation.recommendation}</Typography>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
            {explanation.caveat}
        </Typography>
    </Box>
);

export default FraudExplanation;
